import Api from 'src/api/Base'

class GetMostRecentSspsaList extends Api {
  requestUrl = `/api/SspsaTask/recent`
}

export default GetMostRecentSspsaList
